// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.recent-orders {\n    margin-top: 20px;\n}\n.order-item {\n    margin-bottom: 10px;\n}\n.order-id {\n    font-weight: bold;\n}\n.order-actions {\n    float: right;\n    margin-top: 25px;\n}\n.action-view {\n    color: blue;\n    cursor: pointer;\n}\n.order-divider {\n    border-top: 1px solid #ccc;\n    margin: 10px 0;\n}\n\n", ""]);
// Exports
module.exports = exports;
